import React, { Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const SettingsV2SmokePage = React.lazy(() => import('./SettingsV2SmokePage'));

export const settingsV2SmokeRouter: RouteObject = {
  path: 'dev/settings-v2-smoke',
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-p-4">
          <Skeleton width="100%" height="100%" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  ),
  children: [{ index: true, element: <SettingsV2SmokePage /> }],
};
